// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.
import { Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { D3eService } from '../../../services/d3e-service';
import { UserService } from '../../../services/user-service';
import { ActionService } from '../../../services/action-service';
import { get_uuid_filename } from '../../../shared/subscription.methods';
import multiDownload from 'multi-download';
import { AuthService } from '../../../services/auth-service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-agent-download',
  standalone: false,
  templateUrl: './agent-download.component.html',
  styleUrl: './agent-download.component.scss'
})
export class AgentDownloadComponent implements OnInit {
    constructor(
      private route: ActivatedRoute,
      private d3eService: D3eService,
      public userService: UserService,
      private actionService: ActionService,
      private authService: AuthService,
      private readonly destroyRef: DestroyRef,
    ) { }

    ngOnInit(): void {
        this.authService.showNav.next(false);
        this.authService.showToolbar.next(false);
        this.authService.showBanners.next(false);

        this.route.params.subscribe(params => {
          this.d3eService.get_d3e_software_version(params.uuid)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe(softwareVersion => {
            const filename = get_uuid_filename(softwareVersion, softwareVersion.system, params.uuid).split('/').pop();

            if (!softwareVersion?.win_agent_versions || softwareVersion?.win_agent_versions.length == 0) {
              return;
            }
            const agentPath = softwareVersion?.win_agent_versions[0].url;
            this.actionService.postDownloadBySubUUID(filename, params.uuid, 'download_win_agent_exe')
              .subscribe(() => {
                multiDownload([agentPath], {
                  rename: () => filename,
              });
            });
          });
        });
    }

    protected isLoggedIn(): boolean {
        return this.authService.isLoggedIn;
    }
}
